import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthorizationService } from '../core/authorization.service';
import { map } from 'rxjs/operators';

@Injectable()
export class AppPermissionGuardService implements CanActivate {
  constructor(private router: Router, private authorizationService: AuthorizationService) {}

  canActivate() {
    return this.authorizationService.getPermissions().pipe(
      map((permissions) => {
        if (permissions.length > 0) {
          return true;
        }
        return this.router.createUrlTree(['/no-permissions']);
      })
    );
  }
}
